import { get_axios_instance, api_variables } from "@/apis/variables.js";

var axios_instance = get_axios_instance(api_variables.SERVICE_LEAVES_SALARY);

//const _pk_name = "id";

const state = {
  data: [],
  leavesData: {},
  isFetching: false,
  isSaving: false,
  isDeleting: false
};

const mutations = {
  set: (state, payload) => {
    state.data = payload;
    //console.log("fetched data", state.data);
  },

  setLeavesData: (state, payload) => {
    if (payload) {
      state.leavesData = payload;
    }
    //console.log("fetched lopsandrlops", state.leavesData);
  },

  addEmployee: (state, payload) => {
    //console.log("payload data from store", payload);
    state.lopsandrlops = payload;
    //console.log("lopsandrlops data", state.lopsandrlops);
    //console.log("state data", state.data);
    // state.data.push(payload);
  },
  setFetching: (state, payload) => {
    state.isFetching = payload;
  },

  setSaving: (state, payload) => {
    state.isSaving = payload;
  },

  setDeleting: (state, payload) => {
    state.isDeleting = payload;
  }
};

const actions = {
  async fetchLeidData({ commit }, payload) {
    // //console.log(
    //   "[state/dashboard/legacydata_last/fetchAllDataofleid] Calling API..."
    // );
    //console.log("payload paygroup id", payload);
    try {
      commit("setFetching", true);
      let res = await axios_instance.get(`/`, {
        params: {
          le_id: payload
        }
      });
      commit("setFetching", false);
      // //console.log(
      //   "[state/payroll/legacydata_last/fetchAllDataofleid] res: ",
      //   res
      // );
      if (res.status == 200) {
        commit("setLeavesData", res.data.rows);
      }
      return res;
    } catch (err) {
      //console.log(err);
    }
  },

  async create({ commit }, payload) {
    //console.log("[state/payroll/lopsandrlops/create] Adding...", payload);
    try {
      commit("setSaving", true);
      let res = await axios_instance.post("/", payload);
      commit("setSaving", false);
      //console.log("[state/payroll/lopsandrlops/create] res: ", res);
      if (res.status == 200) {
        commit("addEmployee", payload);
      }
      return res;
    } catch (err) {
      //console.log(err);
    }
  },

  async update({ commit }, payload) {
    // //console.log(
    //   "[state/payroll/lopsandrlops/update] Updating... Display payload",
    //   payload
    // );
    try {
      commit("setSaving", true);
      let res = await axios_instance.put(`/${payload.id}`, payload);
      commit("setSaving", false);
      //console.log("[state/payroll/lopsandrlops/update] res: ", res);
      if (res.status == 200) {
        commit("updateEmployeeById", res.data);
      }
      return res;
    } catch (err) {
      //console.log(err);
    }
  },

  async delete({ commit }, payload) {
    //console.log("[state/payroll/lopsandrlops/delete] Payload:", payload);
    // //console.log(
    //   "[state/payroll/lopsandrlops/delete] Payload:",
    //   `/${payload.id}`
    // );
    try {
      commit("setDeleting", true);
      let res = await axios_instance.delete(`/${payload.id}`);
      commit("setDeleting", false);
      if (res.status == 200) {
        commit("removeEmployeeById", payload.id);
      }
    } catch (err) {
      //console.log(err);
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
